import { TierartEnum } from '@ps20-frontend/frontend-models';
import dayjs from 'dayjs';
import { SpartenType, Zahlungsart, Zahlweise } from '@ps20/bff-models';
import { DATEFORMAT_LOCAL_STATE } from '@ps20-frontend/utils';
import { IAppState } from './appState';
import { GeschlechtEnum } from './reducers/versicherungsnehmer.reducer';
import { mapTierartAufSelbstbeteiligung } from './reducers/vertragsoptionen.reducer';

const TIERART_DEFAULT: TierartEnum = TierartEnum.HUND;

export const INITIAL_STATE: IAppState = {
  version: 10,
  transientState: {
    role: null,
    zurueckZumShopModalOpen: false,
    tarifierungIsInProgress: false,
    priceGuarantee: null,
    fehlerCodeTaas: '',
    featureToggles: {},
    regexps: {},
    kooperationen: null,
  },
  produkt: {
    produktlinien: [],
    uebergreifend: [],
    spartenType: SpartenType.TIERKRANKEN,
    hspLfnr: null,
  },
  versicherungsnehmer: {
    geburtsdatum: null,
    isAssekuranztarif: false,
    juristisch: false,
    tierart: TIERART_DEFAULT,
    geschlecht: GeschlechtEnum.MAENNLICH,
    rasse: null,
    hunderassenAuswahlElemente: null,
    pferderassenAuswahlElemente: null,
    katzenrassenAuswahlElemente: null,
    geburtsdatumTier: null,
    isTierKastriert: null,
    isBehandelt: null,
    behandlungen: {
      mitOperation: false,
      ohneOperation: false,
      ohneTABesuch: false,
    },
    anzahlOperationen: 0,
    hasErkrankungen: null,
    katzenhaltung: null,
  },
  risikoort: {
    plz: '',
    ort: '',
    strasse: '',
    hausnummer: '',
  },
  vorbelegungen: {
    versicherungsnehmerVorbelegt: false,
    adresseImmobilieVorbelegt: false,
  },
  adressvorschlag: {
    orte: [],
    strassen: [],
    lastError: null,
  },
  vertragsoptionen: {
    selbstbeteiligung: mapTierartAufSelbstbeteiligung(TIERART_DEFAULT),
    zahlungsweise: Zahlweise.MONATLICH,
    vertragslaufzeit: 3,
    ausgewaehltevertragslaufzeit: 3,
    zahlungsart: Zahlungsart.LASTSCHRIFT,
    beginnDatum: dayjs().add(1, 'd').format(DATEFORMAT_LOCAL_STATE),
    aenderungdatum: dayjs().add(1, 'd').format(DATEFORMAT_LOCAL_STATE),
    vorversicherungVorhanden: true,
  },
  taasInfo: {
    hashedTaasRequest: '',
    hashedRiskData: '',
    rbdNachlass: 0,
    tbNachlass: 0,
    aktionsnachlass: 0,
    savedRbdNachlass: 0,
    savedTbNachlass: 0,
    savedAktionsnachlass: 0,
  },
  rabattstufe: null,
  gesamtbeitragMitRabatt: 0,
  savedGesamtbeitragMitRabatt: 0,
  savedJahresbeitragMitRabatt: 0,
  jahresbeitrag: 0,
  gesamtbeitrag: 0,
  antragsnummer: '',
};
